import { Injectable } from '@angular/core';
import {ServiziSpontanei} from "../../../models/personal-area/institutiton-categories/servizi-spontanei.model";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {PathStore} from "../../../store/path.store";

@Injectable()
export class CategoriesServiceClient {

  constructor(
    private http: HttpClient,
    private path: PathStore
  ) { }

  public get$(codiceIpa :string): Observable<ServiziSpontanei> {
    return this.http.get<ServiziSpontanei>(this.path.baseURLConfiguration + '/' + this.path.authority_auth_Url  + '/' + codiceIpa + '/' + this.path.serviziSpontaneiUrl);
  }
}
